<form [formGroup]="formGroup">
  <span class="small-title"> {{'proposalDetails.createOfferTab.premiumInformationSection.title'|translate}}</span>

  <div class="field-container">
    <app-input-field [control]="formGroup.controls.referenceValue"
                     [label]="'proposalDetails.createOfferTab.referenceValue'|translate">
      <mat-select formControlName="referenceValue"
                  class="input">
        <ng-container *ngIf="(annualSalesAmount$|async) === 0; else showAllOptions">
          <mat-option *ngFor="let opt of QuestionOptions.referenceValues.slice(0, 2); let i = index" [value]="opt">
            <ng-container>{{'proposalDetails.createOfferTab.referenceValues.' + opt | translate}}</ng-container>
          </mat-option>
        </ng-container>
        <ng-template #showAllOptions>
          <mat-option *ngFor="let opt of QuestionOptions.referenceValues; let i = index" [value]="opt">
            <ng-container>{{'proposalDetails.createOfferTab.referenceValues.' + opt | translate}}</ng-container>
          </mat-option>
        </ng-template>
      </mat-select>
    </app-input-field>
  </div>
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="d-flex flex-row radio-group-premium"
    formControlName="selected">

    <div class="d-flex justify-content-between w-100 premiumAmountContainer">
      <div class="flex-shrink-1 flex-column flex-wrap d-flex w-100" style="min-width: 0">
        <mat-radio-button color="primary" class="example-radio-button align-self-start" [value]="0">
          <div class="d-flex flex-row justify-content-between">
            <div class="small-text">{{'offer.netAmount' |translate}}</div>
            <div *ngIf="selected === 0">{{"*"}}</div>
          </div>

        </mat-radio-button>
        <div class="d-flex justify-content-start w-100">
          <app-input-field [disabledStyle]="selected != 0" [control]="formGroup.controls.premium" [showLabel]="false"
                           class="w-100 field-container" style="min-width: 0">
            <input formControlName="premium"
                   appNumberFormat
                   [maxNumber]="insuredAmount$|async"
                   class="left-rounded input">
          </app-input-field>
          <app-input-field [control]="formGroup.controls.currency" [showLabel]="false">
            <mat-select formControlName="currency"
                        class="right-rounded input"
                        [value]="formGroup.controls.currency" #singleSelect>
              <mat-option>
                <ngx-mat-select-search [formControl]="filterCtrlCurrency"></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
                {{option}}
              </mat-option>

            </mat-select>
          </app-input-field>
        </div>
        <div
          *ngIf="formGroup.value.premium > 0"
          class="premiumAmount">{{this.formGroup.value.premium | numberFormat | async}} {{currencySymbol()}}</div>
      </div>
      <div class="d-flex flex-shrink-2 flex-column premiumAmountMiddleItem w-100" style="min-width: 0">
        <mat-radio-button color="primary" class="example-radio-button align-self-start" [value]="1">
          <div class="d-flex flex-row justify-content-between">
            <div class="small-text">{{'offer.inPercent'|translate}}</div>
            <div *ngIf="selected === 1">{{"*"}}</div>
          </div>
        </mat-radio-button>
        <app-input-field [disabledStyle]="selected != 1" [control]="formGroup.controls.premiumInPercent"
                         [showLabel]="false"
                         class="w-100 field-container">
          <input formControlName="premiumInPercent"
                 appNumberFormat
                 [ratio]="Ratio.PERCENTAGE"
                 decimalPlaces="4"
                 class="input">
        </app-input-field>

      </div>
      <div class="d-flex flex-shrink-2 flex-column w-100" style="min-width: 0">
        <mat-radio-button color="primary" class="example-radio-button align-self-start" [value]="2">
          <div class="d-flex flex-row justify-content-between">
            <div class="small-text">{{'offer.perThousand'|translate}}</div>
            <div *ngIf="selected === 2">{{"*"}}</div>
          </div>
        </mat-radio-button>

        <app-input-field [disabledStyle]="selected != 2" [control]="formGroup.controls.premiumInPerThousand"
                         [showLabel]="false"
                         class="w-100 field-container">
          <input formControlName="premiumInPerThousand"
                 appNumberFormat
                 [ratio]="Ratio.PER_THOUSAND"
                 decimalPlaces="4"
                 class="input">
        </app-input-field>
      </div>
    </div>
  </mat-radio-group>
  <app-input-field class="field-container"
                   [control]="formGroup.controls.offerDescription"
                   [label]="'proposalDetails.createOfferTab.premiumInformationSection.offerDescription'|translate">
              <textarea name="offerDescription"
                        cdkTextareaAutosize
                        [cdkAutosizeMinRows]="3"
                        formControlName="offerDescription"
                        class="input input-text-area"
                        placeholder="{{'proposalDetails.createOfferTab.premiumInformationSection.descriptionPlaceholder' | translate}}"></textarea>
  </app-input-field>
  <div class="d-flex flex-column field-container">
    <div class="d-flex w-100">
      <app-input-field [control]="formGroup.controls.expectedTotalPremium"
                       [label]="'proposalDetails.createOfferTab.premiumInformationSection.expectedTotalPremium'|translate"
                       class="w-100">
        <input name="expectedTotalPremium"
               formControlName="expectedTotalPremium"
               appNumberFormat
               class="input left-rounded">

      </app-input-field>
      <app-input-field [control]="formGroup.controls.currency">
        <mat-select formControlName="currency"
                    class="right-rounded input"
                    [value]="formGroup.controls.currency" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCurrency"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>

    </div>
    <div
      *ngIf="formGroup.value.expectedTotalPremium > 0"
      class="premiumAmount">{{this.formGroup.value.expectedTotalPremium | numberFormat | async}} {{currencySymbol()}}</div>
  </div>
  <div class="d-flex flex-column field-container">
    <div class="d-flex w-100">
      <app-input-field [control]="formGroup.controls.advancePremium"
                       [label]="'proposalDetails.createOfferTab.premiumInformationSection.advancePremium'|translate"
                       class="w-100">
        <input name="advancePremium"
               formControlName="advancePremium"
               appNumberFormat
               class="input left-rounded">

      </app-input-field>
      <app-input-field [control]="formGroup.controls.currency">
        <mat-select formControlName="currency"
                    class="right-rounded input"
                    [value]="formGroup.controls.currency" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCurrency"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>

    </div>
    <div
      *ngIf="formGroup.value.advancePremium > 0"
      class="premiumAmount">{{this.formGroup.value.advancePremium | numberFormat | async}} {{currencySymbol()}}</div>
  </div>
  <div class="d-flex flex-column field-container">
    <div class="d-flex w-100">
      <app-input-field [control]="formGroup.controls.minimumPremium"
                       [label]="'proposalDetails.createOfferTab.premiumInformationSection.minimumPremium'|translate"
                       class="w-100">
        <input name="minimumPremium"
               formControlName="minimumPremium"
               appNumberFormat
               class="input left-rounded">

      </app-input-field>
      <app-input-field [control]="formGroup.controls.currency">
        <mat-select formControlName="currency"
                    class="right-rounded input"
                    [value]="formGroup.controls.currency" #singleSelect>
          <mat-option>
            <ngx-mat-select-search [formControl]="filterCtrlCurrency"></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of filteredOptionsCurrency |async" [value]="option">
            {{option}}
          </mat-option>

        </mat-select>
      </app-input-field>
    </div>
    <div
      *ngIf="formGroup.value.minimumPremium > 0"
      class="premiumAmount">{{this.formGroup.value.minimumPremium | numberFormat | async}} {{currencySymbol()}}</div>
  </div>
  <span
          class="sub-text">{{'offer.includingInsuranceTax'|translate}}</span>
  <div class="field-container">
    <app-input-field [control]="formGroup.controls.typeOfDeductible"
                     [label]="'proposalDetails.createOfferTab.typeOfDeductible'|translate">
      <mat-select formControlName="typeOfDeductible"
                  class="input">
        <mat-option *ngFor="let opt of QuestionOptions.typeOfDeductible;let i = index"
                    [value]="opt">{{'proposalDetails.createOfferTab.typeOfDeductibleOptions.' + opt|translate}}</mat-option>
      </mat-select>
    </app-input-field>
  </div>
  <div class="field-container">
    <ng-container *ngIf="formGroup.value.typeOfDeductible != QuestionOptions.typeOfDeductible[0]">

      <div class="d-flex field-container mb-0">
        <app-input-field [control]="formGroup.controls.deductibleAmountAbsolut" class="w-100"
                         [label]="'proposalDetails.createOfferTab.deductibleAbsoluteAmount'|translate">
          <input
            [maxNumber]="insuredAmount$|async"
            formControlName="deductibleAmountAbsolut"
            appNumberFormat
            class="left-rounded input">
        </app-input-field>
        <app-input-field [control]="formGroup.controls.deductibleCurrency">
          <mat-select formControlName="deductibleCurrency"
                      class="right-rounded input">
            <mat-option *ngFor="let opt of QuestionOptions.currency;let i = index"
                        [value]="opt">{{ opt }}</mat-option>
          </mat-select>
        </app-input-field>
      </div>

      <app-input-field [control]="formGroup.controls.deductiblePercent" class="field-container"
                       [label]="'proposalDetails.createOfferTab.deductiblePercent'|translate">
        <input formControlName="deductiblePercent"
               appNumberFormat
               [ratio]="Ratio.PERCENTAGE"
               class="input">
      </app-input-field>
    </ng-container>
  </div>


</form>
